import Layout from '@/layout/index.vue'

export default [
  {
    path: '/receive',
    redirect: '/delivery',
    component: Layout,
    meta: {
      authRequired: true,
      permission: 'op@yard',
      icon: 'bi bi-truck',
      title: 'Delivery'
    },
    children: [
      {
        path: '/delivery',
        name: 'Delivery',
        component: () => import(/* webpackChunkName: "yard" */ '../Delivery.vue'),
        meta: {
          authRequired: true,
          permission: 'op@yard',
          icon: 'bi bi-truck',
          title: 'Delivery'
        }
      }
    ]
  }
]
